"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UDEMY_ORIGIN_HOST_HEADER = void 0;
exports.resolveOriginHost = resolveOriginHost;
exports.isUFBRequest = isUFBRequest;
exports.UDEMY_ORIGIN_HOST_HEADER = 'x-udemy-origin-host';
/**
 * resolveOriginHost()
 *
 * Resolves the origin host of the request.
 *
 * @param req
 * @returns
 */
function resolveOriginHost(req) {
    return req.headers[exports.UDEMY_ORIGIN_HOST_HEADER];
}
/**
 * isUFBRequest()
 *
 * Determines if a request belongs to a UFB user based on request properites.
 *
 * @param req - client request
 * @returns
 */
function isUFBRequest(req) {
    const host = resolveOriginHost(req) || req.headers.host;
    const subdomain = host === null || host === void 0 ? void 0 : host.split('.')[0];
    if (!host || !subdomain) {
        // Default to `false` if no `host` header is present
        // TODO: improve resolution mechanism
        return false;
    }
    if (process.env.DEPLOY_ENV === 'prod') {
        if (subdomain !== 'www') {
            return true;
        }
    }
    else {
        // TODO: improve + iterate on UB resolution through `*.udemy.dev` domains
        if (subdomain.includes('-') ||
            subdomain.includes('paulatest') ||
            subdomain.includes('learning')) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=request-helpers.js.map